// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wkmR","textarea":"styles_textarea__2VwMC"};